import React from 'react';

import { Type } from '@robinhood/design';

import Cell from 'src/components/creditApplication/Cell';
import CreditApplicationPageLayout from 'src/components/creditApplication/CreditApplicationPageLayout';
import { baseTextInputStyles } from 'src/components/creditApplication/TextInput';
import { LayoutStyle, TextStyle } from 'src/constants/styles';
import { useGlobalStore } from 'src/state/global';
import StudentReferralDisclosure from 'src/views/creditApplication/student/StudentVerificationPage/StudentReferralDisclosure';

const StudentConfirmationPage = () => {
  const email = useGlobalStore((s) => s.personalInformation.email);

  return (
    <CreditApplicationPageLayout
      title='A confirmation link was sent to your email'
      subtitle='Click the link in your email to continue.'
      footer={<StudentReferralDisclosure />}
    >
      <div css={[LayoutStyle.w100, LayoutStyle.mt16, LayoutStyle.flex, LayoutStyle.gap24, TextStyle.textCenter]}>
        <Cell css={[baseTextInputStyles, LayoutStyle.colACJC]}>
          <Type.Text size='M'>{email}</Type.Text>
        </Cell>
        {/* TODO (michelle): add resend email button */}
      </div>
    </CreditApplicationPageLayout>
  );
};

export default StudentConfirmationPage;
